import safeUrl from "@/components/features/widgets/safe-url.js";

// footer_promo: фіксований футер-банер (спадкоємець course-banner з кнопкою «Передзапис»).
// Фон — суцільний bgColor або опційна картинка під оверлеями тексту/кнопки.
export default {
	name	: "footer-promo-widget",
	props	: {
		widget: {
			type		: Object,
			required	: true,
		},
	},
	computed: {
		variables() {
			return this.widget && this.widget.variables ? this.widget.variables : {};
		},
		text() {
			return this.variables.text || "";
		},
		buttonText() {
			return this.variables.buttonText || "";
		},
		linkUrl() {
			return safeUrl(this.variables.linkUrl);
		},
		bgColor() {
			return this.variables.bgColor || "#E7DFCC";
		},
		buttonColor() {
			return this.variables.buttonColor || "#FF6C39";
		},
		textColor() {
			return this.variables.textColor || "#000000";
		},
		imageDesktop() {
			return this.variables.imageDesktop || "";
		},
		imageMobile() {
			return this.variables.imageMobile || "";
		},
		hasImage() {
			return Boolean(this.imageDesktop || this.imageMobile);
		},
		closable() {
			return this.variables.closable !== false;
		},
		rootStyle() {
			return {
				backgroundColor : this.bgColor,
			};
		},
		textStyle() {
			return {
				color : this.textColor,
			};
		},
		buttonStyle() {
			return {
				backgroundColor : this.buttonColor,
			};
		},
	},
	methods: {
		onDismiss() {
			this.$emit("dismiss");
		},
	},
};
